/* tslint:disable */
/* eslint-disable */
/**
 * CallNowButton API
 * API for CallNowButton. Includes auth, domains, buttons/actions/conditions, but also chat and admin features.
 *
 * The version of the OpenAPI document: 0.0.221-development
 * Contact: support@nowbuttons.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ButtonOptions } from './ButtonOptions';
import {
    ButtonOptionsFromJSON,
    ButtonOptionsFromJSONTyped,
    ButtonOptionsToJSON,
    ButtonOptionsToJSONTyped,
} from './ButtonOptions';
import type { MultiButtonOptions } from './MultiButtonOptions';
import {
    MultiButtonOptionsFromJSON,
    MultiButtonOptionsFromJSONTyped,
    MultiButtonOptionsToJSON,
    MultiButtonOptionsToJSONTyped,
} from './MultiButtonOptions';

/**
 * 
 * @export
 * @interface ButtonMinimal
 */
export interface ButtonMinimal {
    /**
     * The unique identifier of the `Button`
     * @type {string}
     * @memberof ButtonMinimal
     */
    id: string;
    /**
     * The ID of the `User` that owns this `Button`
     * @type {string}
     * @memberof ButtonMinimal
     */
    user: string;
    /**
     * The ID of the `Domain` this `Button` belongs to
     * @type {string}
     * @memberof ButtonMinimal
     */
    domain: string;
    /**
     * Whether this `Button` is active
     * @type {boolean}
     * @memberof ButtonMinimal
     */
    active: boolean;
    /**
     * The display name of this `Button`
     * @type {string}
     * @memberof ButtonMinimal
     */
    name: string;
    /**
     * The type of this `Button`
     * @type {string}
     * @memberof ButtonMinimal
     */
    type: ButtonMinimalTypeEnum;
    /**
     * Display options for this `Button` (size, placement, etc.)
     * @type {ButtonOptions}
     * @memberof ButtonMinimal
     */
    options: ButtonOptions;
    /**
     * Options specific to multi-button layouts, or null for single buttons
     * @type {MultiButtonOptions}
     * @memberof ButtonMinimal
     */
    multiButtonOptions?: MultiButtonOptions;
    /**
     * A list of IDs belonging to the `Action`s that are associated with this `Button`
     * @type {Array<string>}
     * @memberof ButtonMinimal
     */
    actions: Array<string>;
    /**
     * A list of IDs belonging to the `Condition`s that are associated with this `Button`
     * @type {Array<string>}
     * @memberof ButtonMinimal
     */
    conditions: Array<string>;
}


/**
 * @export
 */
export const ButtonMinimalTypeEnum = {
    Single: 'SINGLE',
    Multi: 'MULTI',
    Full: 'FULL',
    Dots: 'DOTS'
} as const;
export type ButtonMinimalTypeEnum = typeof ButtonMinimalTypeEnum[keyof typeof ButtonMinimalTypeEnum];


/**
 * Check if a given object implements the ButtonMinimal interface.
 */
export function instanceOfButtonMinimal(value: object): value is ButtonMinimal {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('user' in value) || value['user'] === undefined) return false;
    if (!('domain' in value) || value['domain'] === undefined) return false;
    if (!('active' in value) || value['active'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('options' in value) || value['options'] === undefined) return false;
    if (!('actions' in value) || value['actions'] === undefined) return false;
    if (!('conditions' in value) || value['conditions'] === undefined) return false;
    return true;
}

export function ButtonMinimalFromJSON(json: any): ButtonMinimal {
    return ButtonMinimalFromJSONTyped(json, false);
}

export function ButtonMinimalFromJSONTyped(json: any, ignoreDiscriminator: boolean): ButtonMinimal {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'user': json['user'],
        'domain': json['domain'],
        'active': json['active'],
        'name': json['name'],
        'type': json['type'],
        'options': ButtonOptionsFromJSON(json['options']),
        'multiButtonOptions': json['multiButtonOptions'] == null ? undefined : MultiButtonOptionsFromJSON(json['multiButtonOptions']),
        'actions': json['actions'],
        'conditions': json['conditions'],
    };
}

export function ButtonMinimalToJSON(json: any): ButtonMinimal {
    return ButtonMinimalToJSONTyped(json, false);
}

export function ButtonMinimalToJSONTyped(value?: ButtonMinimal | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'user': value['user'],
        'domain': value['domain'],
        'active': value['active'],
        'name': value['name'],
        'type': value['type'],
        'options': ButtonOptionsToJSON(value['options']),
        'multiButtonOptions': MultiButtonOptionsToJSON(value['multiButtonOptions']),
        'actions': value['actions'],
        'conditions': value['conditions'],
    };
}

